<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="当天日期">
<!--                  <el-input style="width: 177px;" v-model="queryForm.dayDate"></el-input>-->
                  <el-date-picker
                      style="width: 177px;"
                      size="small"
                      v-model="queryForm.dayDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getOperationDailyactiveUserList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addOperationDailyactiveUser"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editOperationDailyactiveUser(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteOperationDailyactiveUser(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshOperationDailyactiveUserList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="operationDailyactiveUserList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="当天日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currentScore"
        label="当时拥有的贡献值"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isSend"
        label="是否已发放"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalScore"
        label="结算时总的贡献值"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalMoney"
        label="结算时总的应该发放的抵扣券"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendMoney"
        label="放发抵扣券数量"
        width="180"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkOperationDailyactiveUser(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editOperationDailyactiveUser(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteOperationDailyactiveUser(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="operationDailyactiveUserStates[operationDailyactiveUserState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="operationDailyactiveUser"
          ref="operationDailyactiveUserForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationDailyactiveUser.userId"-->
<!--              :disabled="operationDailyactiveUserState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName" :disabled="operationDailyactiveUserState == 'check'"
                           labelValue="id" title="选择用户" :value="operationDailyactiveUser.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="当天日期"
            prop="dayDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="operationDailyactiveUser.dayDate"-->
<!--              :disabled="operationDailyactiveUserState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style="width: 177px;"
                  size="small"
                  v-model="operationDailyactiveUser.dayDate"
                  :disabled="operationDailyactiveUserState == 'check'"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="当时拥有的贡献值"
            prop="currentScore"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyactiveUser.currentScore"
              :disabled="operationDailyactiveUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否已发放"
            prop="isSend"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="operationDailyactiveUser.isSend"-->
<!--              :disabled="operationDailyactiveUserState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="operationDailyactiveUser.isSend"
                  :disabled="operationDailyactiveUserState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option label="已发放" :value="1"></el-option>
                  <el-option label="未发放" :value="0"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="结算时总的贡献值"
            prop="totalScore"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyactiveUser.totalScore"
              :disabled="operationDailyactiveUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="结算时总的应该发放的抵扣券"
            prop="totalMoney"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyactiveUser.totalMoney"
              :disabled="operationDailyactiveUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="放发抵扣券数量"
            prop="sendMoney"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationDailyactiveUser.sendMoney"
              :disabled="operationDailyactiveUserState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="operationDailyactiveUserState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetOperationDailyactiveUserList();
                    this.getOperationDailyactiveUserList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetOperationDailyactiveUserList();
                    this.getOperationDailyactiveUserList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     dayDate: '', //当天日期
                     currentScore: '', //当时拥有的贡献值
                     isSend: '', //是否已发放
                     totalScore: '', //结算时总的贡献值
                     totalMoney: '', //结算时总的应该发放的抵扣券
                     sendMoney: '', //放发抵扣券数量
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                operationDailyactiveUserState: 'add',
                operationDailyactiveUserStates: {
                    add: '新建活跃用户贡献值记录',
                    check: '查看活跃用户贡献值记录',
                    edit: '修改活跃用户贡献值记录'
                },

                multipleSelection: [],
                operationDailyactiveUserList: [],
                operationDailyactiveUser: {
                    id: '', //
                    userId: '', //用户
                    dayDate: '', //当天日期
                    currentScore: '', //当时拥有的贡献值
                    isSend: '', //是否已发放
                    totalScore: '', //结算时总的贡献值
                    totalMoney: '', //结算时总的应该发放的抵扣券
                    sendMoney: '', //放发抵扣券数量
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    dayDate: [{ required: true, message: '当天日期不能为空', trigger: 'blur' }],
                    currentScore: [{ required: true, message: '当时拥有的贡献值不能为空', trigger: 'blur' }],
                    isSend: [{ required: true, message: '是否已发放不能为空', trigger: 'blur' }],
                    totalScore: [{ required: true, message: '结算时总的贡献值不能为空', trigger: 'blur' }],
                    totalMoney: [{ required: true, message: '结算时总的应该发放的抵扣券不能为空', trigger: 'blur' }],
                    sendMoney: [{ required: true, message: '放发抵扣券数量不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getOperationDailyactiveUserList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetOperationDailyactiveUserList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.operationDailyactiveUserList = [];
            },
            getValueUser(value){
                this.operationDailyactiveUser.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            resetDialog() {
                this.operationDailyactiveUserState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      dayDate: '', //当天日期
                      currentScore: '', //当时拥有的贡献值
                      isSend: '', //是否已发放
                      totalScore: '', //结算时总的贡献值
                      totalMoney: '', //结算时总的应该发放的抵扣券
                      sendMoney: '', //放发抵扣券数量
                };
                this.getOperationDailyactiveUserList();
            },
            closeDialog() {
                this.showDialog = false
                this.operationDailyactiveUser = {
                      id: '', //
                      userId: '', //用户
                      dayDate: '', //当天日期
                      currentScore: '', //当时拥有的贡献值
                      isSend: '', //是否已发放
                      totalScore: '', //结算时总的贡献值
                      totalMoney: '', //结算时总的应该发放的抵扣券
                      sendMoney: '', //放发抵扣券数量
                };
            },
            submitForm() {
                if (this.operationDailyactiveUserState == 'add') {
                    this.$refs.operationDailyactiveUserForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/operation/dailyactiveuser/add`,{ ...this.operationDailyactiveUser }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetOperationDailyactiveUserList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.operationDailyactiveUserState == 'edit') {
                    this.$refs.operationDailyactiveUserForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.operationDailyactiveUser.user
                            post(`/operation/dailyactiveuser/edit`,{ ...this.operationDailyactiveUser }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetOperationDailyactiveUserList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addOperationDailyactiveUser() {
                this.showDialog = true;
                this.operationDailyactiveUserState = 'add';
            },
            checkOperationDailyactiveUser(operationDailyactiveUserId) {
                console.log(operationDailyactiveUserId);
                this.currentOperationDailyactiveUserId = operationDailyactiveUserId;

                this.getOperationDailyactiveUserById();
                this.showDialog = true;
                this.operationDailyactiveUserState = 'check';
            },
            editOperationDailyactiveUser(operationDailyactiveUserId) {
                console.log('operationDailyactiveUser', operationDailyactiveUserId);
                if (operationDailyactiveUserId) {
                    this.currentOperationDailyactiveUserId = operationDailyactiveUserId;
                    this.getOperationDailyactiveUserById();
                } else {
                    this.operationDailyactiveUser = { ...this.operationDailyactiveUser, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.operationDailyactiveUserState = 'edit';
            },
            deleteOperationDailyactiveUser(operationDailyactiveUserId) {
                let ids = '';
                if (operationDailyactiveUserId) {
                    ids = operationDailyactiveUserId;
                } else {
                    ids = this.multipleSelection.map((operationDailyactiveUser) => operationDailyactiveUser.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/operation/dailyactiveuser/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetOperationDailyactiveUserList();
                                this.getOperationDailyactiveUserList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshOperationDailyactiveUserList() {
                this.resetOperationDailyactiveUserList();
                this.getOperationDailyactiveUserList();
            },
            getOperationDailyactiveUserList(query = {}) {
                this.loading = true;
                get(`/operation/dailyactiveuser/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.operationDailyactiveUserList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getOperationDailyactiveUserById() {
                get(`/operation/dailyactiveuser/get`,{ id: this.currentOperationDailyactiveUserId }).then((res) =>{
                    if(res.success){
                      this.operationDailyactiveUser = { ...this.operationDailyactiveUser, ...res.operationDailyactiveUser };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportOperationDailyactiveUserList() {
                //this.btnLoading = true;
                exprotExcel(`/operation/dailyactiveuser/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/operation/dailyactiveuser/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/operation/dailyactiveuser/importData`,formData);
              this.refreshOperationDailyactiveUserList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getOperationDailyactiveUserList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getOperationDailyactiveUserList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>